import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { verifyCode, resendCode } from '../features/authSlice';
import ResetPasswordBox from './ResetPasswordBox';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/forgotpassword.css';

const VerifyAccountBox = ({ email }) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [timer, setTimer] = useState(59);
  const [resending, setResending] = useState(false);
  const [showReset, setShowReset] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => setTimer(t => t - 1), 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  const handleVerify = async (e) => {
    e.preventDefault();
    if (!code) {
      setError('Code is required');
      return;
    }
    if (code.length !== 6) {
      setError('Code must be 6 digits');
      return;
    }
    setError('');
    const result = await dispatch(verifyCode({ email, otp: code }));
    if (verifyCode.fulfilled.match(result)) {
      toast.success('Account verified!');
      setShowReset(true);
    } else {
      toast.error(result.payload || 'Verification failed');
    }
  };

  const handleResend = async () => {
    setResending(true);
    await dispatch(resendCode({ email }));
    setTimer(59);
    setResending(false);
  };

  // Mask email: show first and last letter of username, mask rest with *
  const getMaskedEmail = (email) => {
    if (!email) return '';
    const [user, domain] = email.split('@');
    if (!user || !domain) return email;
    if (user.length <= 2) return user[0] + '*@' + domain;
    return (
      user[0] + '*'.repeat(user.length - 2) + user[user.length - 1] + '@' + domain
    );
  };

  return (
    showReset ? (
      <ResetPasswordBox email={email} />
    ) : (
      <>
         <div className="login-form">
                          <h1>Verify Account</h1>
                          <h3>Code has been sent to <span style={{ fontWeight: 700, color: '#00A3B4' }}>{getMaskedEmail(email)}</span>.<br />
            Enter the code to verify your account.</h3>
            <form onSubmit={handleVerify} className="form-info">
            <label htmlFor="code" className="form-label">Enter Code</label>
            <input
              id="code"
              type="text"
              className="form-input"
              placeholder="Enter the 6 Digit Code"
              value={code}
              onChange={e => {
                setCode(e.target.value.replace(/[^0-9]/g, ''));
                if (error) setError('');
              }}
              maxLength={6}
              style={{ borderColor: error ? '#D7184D' : '' }}
            />
            {error && <span className="login-input-error">{error}</span>}
            <div className="receive-code">
              Didn’t Receive Code?{' '}
              <span
                style={{ color: '#00bcd4', fontWeight: 400, cursor: resending || timer > 0 ? 'not-allowed' : 'pointer', textDecoration: 'underline' }}
                onClick={timer === 0 && !resending ? handleResend : undefined}
                aria-disabled={timer > 0 || resending}
              >
                Resend Code
              </span>
            </div>
            <div className="resend-text">
              Resend code in 00:{timer.toString().padStart(2, '0')}
            </div>
            <button type="submit" className="login-btn">
              Verify and Proceed
            </button>
          </form>
                        
        </div>
       
      </>
    )
  );
};

export default VerifyAccountBox;
